import React, { useContext, useEffect, useRef, useState } from 'react'
import { withTheme } from 'theming'
import SliderWrapper from './_slickSliderStyle'
import CustomImage from '../../components/customImage/customImage'
import useTemplateHook from '../../components/template/templateHook'
import LatestIcon from '../../assets/carta/latest-postion-icon.svg'
import NominationIcon from '../../assets/carta/new-nomination-icon.svg'
import ReleasedIcon from '../../assets/carta/released-icon.svg'
import ArrowIcon from '../../assets/arrow-next-small-svgrepo-com@3x.png'
import PrevIcon from '../../assets/rotated-arrow.png'
import Slider from 'react-slick'
import { isEmpty } from 'lodash'
import VoteIcon from '../../assets/carta/voteIcon'
import { POLL_API } from '../../utils/apiUrls'
import { AppContext } from '../../context/app'
import useAxios from 'axios-hooks'
import { getYoutubeVideoThumbnail } from '../../utils/helper'

const PoleHome = ({ theme }) => {
  const { setLoader, setOpenLoginModal, isLogin } = useContext(AppContext)
  const sliderRef = useRef(null)
  const [bannerData, setBannerData] = useState([])
  const [votingPollData, setVotingPollData] = useState({})
  const [releasedPollData, setReleasedPollData] = useState({})
  const [setting, setSetting] = useState({})
  const [voteCountAllowed, setVoteCountAllowed] = useState(1)
  const [castedVote, setCastedVote] = useState([])
  const { getTemplateImage } = useTemplateHook()

  const [toggle, setToggle] = useState('LATEST')

  const [{ data: castVoteData }, castVoteCall] = useAxios(
    {
      url: `${POLL_API}/vote`,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: userVotes, loading: userVotesLoading }, userVotesCall] = useAxios(
    {
      url: `${POLL_API}/vote`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: pollData, loading: pollDataLoading }, pollDataCall] = useAxios(
    {
      url: `${POLL_API}/`,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    pollDataCall()
  }, [])

  useEffect(() => {
    setLoader(pollDataLoading || userVotesLoading)
  }, [pollDataLoading, userVotesLoading])

  useEffect(() => {
    if (castVoteData && castVoteData.success) {
      userVotesCall({ url: `${POLL_API}/vote/${votingPollData._id}` })
    }
  }, [castVoteData])

  useEffect(() => {
    if (userVotes && userVotes.success) {
      setCastedVote(userVotes.data)
    }
  }, [userVotes])

  useEffect(() => {
    if (pollData && pollData.success && !isEmpty(pollData.data)) {
      let votingPoll = pollData.data.find((info) => info.is_voting_publish)
      let releasedPoll = pollData.data.find((info) => info.is_poll_released)

      if (votingPoll) {
        setVotingPollData(votingPoll)
        setBannerData(votingPoll.banner_data)
        setVoteCountAllowed(votingPoll.allowed_votes)
        if (isLogin) {
          userVotesCall({ url: `${POLL_API}/vote/${votingPoll._id}` })
        }
      }
      if (releasedPoll) {
        setReleasedPollData(releasedPoll)
      }
    }
  }, [pollData, isLogin])

  function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'flex',
          justifyContent: 'flex-start',
          background: `transaprent`,
          width: '10.5px',
          height: '17.5px',
          position: 'absolute',
          top: '48%',
          right: '-3.6%',
          content: `url(${ArrowIcon})`,
        }}
        onClick={onClick}
      >
        NextArrow
      </div>
    )
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={`${className} rotate-180`}
        style={{
          ...style,
          display: 'block',
          background: `transaprent`,
          width: '10.5px',
          height: '17.5px',
          position: 'absolute',
          top: '48%',
          left: '-3.6%',
          content: `url(${PrevIcon})`,
          zIndex: '10',
        }}
        onClick={onClick}
      >
        PrevArrow
      </div>
    )
  }

  useEffect(() => {
    setSetting({
      dots: true,
      autoplay: false,
      autoplaySpeed: 2500,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: true,
      nextArrow: <SampleNextArrow transform={128} />,
      prevArrow: <SamplePrevArrow transform={128} />,
      adaptiveHeight: true,
      appendDots: (dots) => {
        return (
          <div
            style={{
              background: 'transparent',
              borderRadius: '0px',
              padding: '0px',
              zIndex: 0,
            }}
            className="border"
          >
            <ul style={{ marginTop: '5px' }} className="mb-0">
              {dots.map((info, idx) => (
                <li key={idx} className={`${info.props.className}`}>
                  <div
                    style={{
                      backgroundColor: `${
                        info.props.className === 'slick-active' ? '#f9af2e' : '#ffffff70'
                      }`,
                    }}
                    className="ft-slick__dots--custom"
                    onClick={info.props.children.props.onClick}
                  >
                    <div className="" />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )
      },
      customPaging: (i) => (
        <div className="ft-slick__dots--custom">
          <div className="" />
        </div>
      ),
    })
    // const sliderElement = sliderRef.current
    // if (sliderElement) {
    //   if (data?.carousel_data?.auto_slide) {
    //     sliderElement.slickPlay()
    //   } else {
    //     sliderElement.slickPause()
    //   }
    // }
  }, [theme])

  const castVote = (info) => {
    if (!isLogin) {
      setOpenLoginModal(true)
    }
    if (castedVote.length >= voteCountAllowed) {
      return
    }

    castVoteCall({
      data: {
        poll_id: votingPollData._id,
        track_uuid: info.uuid,
      },
    })
  }

  const checkVoteCasted = (trackUuid) => {
    let obj = castedVote.find((info) => info.track_uuid === trackUuid)
    return !isEmpty(obj)
  }

  const reDirectYoutube = (info) => {
    if (!info.youtube_id) return
    window.open(
      `https://www.youtube.com/watch?v=${info.youtube_id}`,
      '_blank',
      'noopener,noreferrer',
    )
  }

  return (
    <div style={{ padding: '0.25% 0%' }} className="flex justify-center items-center w-full">
      {!pollDataLoading ? (
        <div className="w-[94.5%] md:w-[85%] xl:w-[1278px] 2xl:w-[1530px] flex justify-between">
          <div className=" w-[41.94%]  hidden xl:block">
            <div style={{ marginTop: '23px' }} className="w-full ">
              {!isEmpty(setting) && !isEmpty(bannerData) && (
                <SliderWrapper className="">
                  <Slider ref={sliderRef} {...setting}>
                    {bannerData.map((banner, idx) => (
                      <div key={idx} className={`w-full`} style={{}}>
                        <div className={`rounded-[10px] overflow-hidden w-full  `}>
                          <CustomImage
                            imageUrl={getTemplateImage(banner)}
                            imgClass="w-full h-full"
                            loaderClass="w-full h-full"
                            loaderStyle={{
                              background: '#5A5A5A50',
                            }}
                            imgAlt={'category'}
                            imgStyle={{ aspectRatio: '536/446' }}
                          />
                        </div>
                      </div>
                    ))}
                  </Slider>
                </SliderWrapper>
              )}
            </div>
          </div>
          <div className="w-full xl:w-[52.58%]">
            <div style={{ color: '#b5b5b5' }} className="w-full flex justify-end text-xs">
              {toggle === 'LATEST'
                ? `${castedVote.length} of ${voteCountAllowed} Votes casted`
                : toggle === 'NEW_NOMINATION'
                ? 'New Tracks of this week'
                : ' Top Tracks of this week'}
            </div>
            <div style={{ marginTop: '7px' }} className="flex justify-between items-center">
              <div
                style={{
                  width: '33%',
                  height: '30px',
                  boxShadow: '0 -4px 6px 0 rgba(0, 0, 0, 0.22)',
                  borderTopLeftRadius: '8px',
                  borderBottomLeftRadius: '8px',
                  backgroundImage:
                    toggle === 'LATEST'
                      ? 'linear-gradient(to bottom, #256eef, #00264e)'
                      : 'linear-gradient(to bottom, #3e3e3e, #1c1c1c)',
                  color: '#e3e2e2',
                }}
                className="xl:font-medium  text-[11.5px] xl:text-sm text-center cursor-pointer flex items-center justify-center"
                onClick={() => setToggle('LATEST')}
              >
                <img src={LatestIcon} alt="Latest" className="mx-1 xl:mx-2 w-[9.7px] xl:w-auto" />{' '}
                Latest Position
              </div>
              <div
                style={{
                  width: '33%',
                  height: '30px',
                  boxShadow: '0 -4px 6px 0 rgba(0, 0, 0, 0.22)',
                  color: '#e3e2e2',
                  backgroundImage:
                    toggle === 'NEW_NOMINATION'
                      ? 'linear-gradient(to bottom, #256eef, #00264e)'
                      : 'linear-gradient(to bottom, #3e3e3e, #1c1c1c)',
                }}
                className="xl:font-medium  text-[11.5px] xl:text-sm text-center cursor-pointer flex items-center justify-center"
                onClick={() => setToggle('NEW_NOMINATION')}
              >
                <img
                  src={NominationIcon}
                  alt="Nomination"
                  className="mx-1 xl:mx-2 w-[9.7px] xl:w-auto"
                />{' '}
                New Nominations
              </div>
              <div
                style={{
                  width: '33%',
                  height: '30px',
                  boxShadow: '0 -4px 6px 0 rgba(0, 0, 0, 0.22)',
                  borderTopRightRadius: '8px',
                  borderBottomRightRadius: '8px',
                  color: '#e3e2e2',
                  backgroundImage:
                    toggle === 'RELEASED_SONG'
                      ? 'linear-gradient(to bottom, #256eef, #00264e)'
                      : 'linear-gradient(to bottom, #3e3e3e, #1c1c1c)',
                }}
                className="xl:font-medium  text-[11.5px] xl:text-sm text-center cursor-pointer flex items-center justify-center"
                onClick={() => setToggle('RELEASED_SONG')}
              >
                <img
                  src={ReleasedIcon}
                  alt="Released"
                  className="mx-1 xl:mx-2 w-[9.7px] xl:w-auto"
                />{' '}
                Released Song
              </div>
            </div>
            <div style={{ color: '#b5b5b5' }} className="w-full mt-1 flex justify-start text-xs">
              <p
                style={{}}
                className="text-[10px] xl:text-xs flex items-center justify-center w-[8.108%] xl:w-[6.409%] "
              >
                #
              </p>
              <p
                className={` text-[10px] xl:text-xs ${
                  toggle === 'LATEST' ? 'w-[37%] xl:w-[16.5454%]' : 'w-auto'
                } h-full flex items-center `}
              >
                {toggle === 'LATEST'
                  ? 'Tracks for voting'
                  : toggle === 'NEW_NOMINATION'
                  ? 'New Tracks'
                  : 'Tracks of the Week'}
              </p>
              {toggle === 'LATEST' ? (
                <>
                  <p className="hidden xl:block xl:w-2/5  h-full " />
                  <p className="text-[10px] xl:text-xs w-[27.027%] xl:w-[23%] xl:pl-[3.03%] flex items-center">
                    Voting Status
                  </p>
                </>
              ) : null}
            </div>
            <div style={{ height: '473px', marginTop: '2px' }} className=" scrollbar-class">
              {toggle === 'LATEST' || toggle === 'NEW_NOMINATION' ? (
                !isEmpty(votingPollData?.tracks_data) ? (
                  [...votingPollData?.tracks_data]
                    .filter(
                      (info) =>
                        info?.youtube_id && (toggle === 'NEW_NOMINATION' ? info.new_entry : true),
                    )
                    .map((data, idx) => (
                      <div
                        style={{
                          background: '#1c1c1c',
                          borderRadius: '6px',
                          marginTop: idx ? '6px' : '0',
                        }}
                        key={idx}
                        className="w-full h-[64px] xl:h-[60px] flex items-center"
                      >
                        <div
                          style={{ color: '#e3e2e2' }}
                          className="text-[11.5px] xl:text-xs flex items-center justify-center w-[8.108%] xl:w-[6.409%]"
                        >
                          {' '}
                          {idx + 1}{' '}
                        </div>
                        <div
                          className={`${
                            toggle === 'LATEST' ? 'w-[37%]' : 'w-2/3'
                          } text-[11.5px] xl:text-xs ] xl:w-[16.5454%] h-full flex justify-center xl:justify-start flex-col xl:flex-row xl:items-center`}
                        >
                          <CustomImage
                            imageUrl={getYoutubeVideoThumbnail(data?.youtube_id)}
                            imgAlt={data.youtube_title}
                            imgClass="w-[67.2px] h-[38.3] xl:w-[91.4px] xl:h-[52.1px] rounded"
                          />
                          <div
                            style={{
                              color: '#e3e2e2',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                            className="block xl:hidden text-[10px]"
                          >
                            {data.youtube_title}
                          </div>
                        </div>
                        <div
                          style={{ color: '#e3e2e2' }}
                          className={`hidden xl:block text-xs ${
                            toggle === 'LATEST' ? 'xl:w-[40.75%]' : 'xl:w-[60%]'
                          }  pr-4 xl:line-clamp-2`}
                        >
                          {data.youtube_title}
                        </div>
                        {toggle === 'LATEST' ? (
                          <div
                            style={{ color: checkVoteCasted(data.uuid) ? '#13fd00' : '#ffffff' }}
                            className={`text-[11.5px] xl:text-xs w-[32.43%]  xl:w-[23%] pl-[1%] xl:pl-[3.03%] flex items-center ${
                              checkVoteCasted(data.uuid) ? '' : 'cursor-pointer'
                            } `}
                            onClick={checkVoteCasted(data.uuid) ? () => {} : () => castVote(data)}
                          >
                            <VoteIcon
                              iconClass={''}
                              color={checkVoteCasted(data.uuid) ? '#13fd00' : '#ffffff'}
                            />
                            <p className="ml-1 xl:ml-2">
                              {checkVoteCasted(data.uuid) ? 'Already Voted' : 'Vote'}
                            </p>
                          </div>
                        ) : null}
                        <div
                          style={{ color: '#e3e2e2' }}
                          className="text-[11.5px] xl:text-xs w-[21.08%] xl:w-[13.03%] flex items-center cursor-pointer"
                          onClick={() => reDirectYoutube(data)}
                        >
                          Watch Now
                        </div>
                      </div>
                    ))
                ) : (
                  <p className="text-center mt-20" style={{ color: '#b5b5b5' }}>
                    {toggle === 'LATEST' ? 'No Tracks for voting' : ' No New Nominations'}
                  </p>
                )
              ) : null}

              {toggle === 'RELEASED_SONG' ? (
                !isEmpty(releasedPollData?.tracks_data) ? (
                  [...releasedPollData.tracks_data]
                    .filter((info) => info?.youtube_id)
                    .map((data, idx) => (
                      <div
                        style={{
                          background: '#1c1c1c',
                          borderRadius: '6px',
                          marginTop: idx ? '6px' : '0',
                        }}
                        key={idx}
                        className="w-full h-[64px] xl:h-[60px] flex items-center"
                      >
                        <div
                          style={{ color: '#e3e2e2' }}
                          className="text-[11.5px] xl:text-xs flex items-center justify-center w-[8.108%] xl:w-[6.409%]"
                        >
                          {' '}
                          {idx + 1}{' '}
                        </div>
                        <div
                          className={` w-2/3 text-[11.5px] xl:text-xs ] xl:w-[16.5454%] h-full flex justify-center xl:justify-start flex-col xl:flex-row xl:items-center`}
                        >
                          <CustomImage
                            imageUrl={getYoutubeVideoThumbnail(data?.youtube_id)}
                            imgAlt={data.youtube_title}
                            imgClass="w-[67.2px] h-[38.3] xl:w-[91.4px] xl:h-[52.1px] rounded"
                          />
                          <div
                            style={{
                              color: '#e3e2e2',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                            className="block xl:hidden text-[10px]"
                          >
                            {data.youtube_title}
                          </div>
                        </div>
                        <div
                          style={{ color: '#e3e2e2' }}
                          className={`hidden xl:block text-xs xl:w-[60%] pr-4 xl:line-clamp-2`}
                        >
                          {data.youtube_title}
                        </div>

                        <div
                          style={{ color: '#e3e2e2' }}
                          className="text-[11.5px] xl:text-xs w-[21.08%] xl:w-[13.03%] flex items-center cursor-pointer"
                          onClick={() => reDirectYoutube(data)}
                        >
                          Watch Now
                        </div>
                      </div>
                    ))
                ) : (
                  <p className="text-center mt-20" style={{ color: '#b5b5b5' }}>
                    No Released Songs
                  </p>
                )
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default withTheme(PoleHome)
